import Axios from 'axios';
import { getUniqueReferenceNumber } from '../utils/common';
import { METHODS } from './constants';
// import { routes } from '../config/routes';

let headers: any = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
};

export const setAuthToken = (authToken: string) => {
  headers.Authorization = `${authToken}`;
};

export const getAuthToken = () => {
  return headers.Authorization;
};

export const unsetAuthToken = () => {
  delete headers['Authorization'];
};

export const setTransactionId = () => {
  headers['X-Reference'] = getUniqueReferenceNumber();
};

export const unsetTransactionId = () => {
  delete headers['X-Reference'];
};

/**
 * Extracts browser config optons from window navigator object and stringifies it.
 */
export const setBrowserConfig = () => {
  let _navigator: any = {};
  ({
    appName: _navigator.appName,
    appVersion: _navigator.appVersion,
    platform: _navigator.platform,
  } = window.navigator);
  headers['Browser-Key'] = JSON.stringify(_navigator);
};

/**
 * to unset the browser config from the request header
 */
export const unsetBrowserConfig = () => {
  delete headers['Browser-Key'];
};

export const utils = {
  getHeaders: () => {
    return headers;
  },

  fetch: (url, options?: any) => {
    return new Promise((resolve, reject) => {
      const headers = options?.headers;
      Axios({
        url,
        ...options,
        credentials: 'same-origin',
        headers: { ...utils.getHeaders(), ...headers },
      })
        .then(resolve)
        .catch((error) => {
          if (error.response?.status === 401) {
            return;
          }
          reject(error);
        });
    });
  },

  downloadFetcher: (url, fileName: string, options?: any) => {
    return new Promise((resolve, reject) => {
      const headers = { Accept: 'application/pdf,application/json' };
      Axios({
        url,
        ...options,
        method: METHODS.GET,
        credentials: 'same-origin',
        headers: { ...utils.getHeaders(), ...headers },
        responseType: 'arraybuffer',
        transformResponse: arrayBufferToObject,
      })
        .then(
          (res: any) => {
            let data = '';
            const extension = '.pdf';
            if (navigator.msSaveBlob) {
              // IE10+
              let dataBlob;
              if (res.data.constructor.name === 'String') {
                dataBlob = dataURLtoBlob(data);
              }
              return navigator.msSaveBlob(dataBlob, `${fileName}${extension}`);
            }
            if (res?.data.constructor.name !== 'String') {
              data = transformBufferToBase64(res?.data);
            }

            // Insert a link that allows the user to download the PDF file
            var link = document.createElement('a');
            link.innerHTML = 'Download PDF file';
            link.download = `${fileName}${extension}`;
            link.href = 'data:application/octet-stream;base64,' + data;
            document.body.appendChild(link);
            link.click();
            link.remove();
            resolve(res.data);
          },
          (err: any) => {
            reject(err);
          }
        )
        .catch((error) => {
          if (error.response?.status === 401) {
            return;
          }
          reject(error);
        });
    });
  },
};

const transformBufferToBase64 = (buff) => {
  let base64Str = '';
  const bytes = new Uint8Array(buff);
  const length = bytes.length;
  for (let i = 0; i < length; i++) {
    base64Str += String.fromCharCode(bytes[i]);
  }

  return base64Str;
};

const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

const arrayBufferToObject = (data: ArrayBufferView | ArrayBuffer | undefined, headers: any) => {
  if (headers['content-type'] === 'application/json') {
    var decoder = new TextDecoder('utf-8');
    var domString = decoder.decode(data);
    var json = JSON.parse(domString);
    return json;
  } else {
    return data;
  }
};

export const getRedirectionUrlFromAPI = (apiUrl: string) => {
  // if (apiUrl.includes('investment-ids') || apiUrl.includes('notifications')) {
  //   return routes.PORTFOLIO.url;
  // }
  return '/';
};

export const removeHttpAndHttpsProtocolFromString = (url: string) => {
  // Remove the http:// or https:// from the URL
  const newUrl = url.replace(/(^\w+:|^)\/\//, '');
  return newUrl;
};

export default utils;
